import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);
var DEFAULT_DATE_TIME_FORMAT = process.env.DATE_TIME_FORMAT || process.env.NEXT_PUBLIC_DATE_TIME_FORMAT || "YYYY-MM-DD HH:mm";
function formatDate(date, format) {
  if (format === void 0) {
    format = DEFAULT_DATE_TIME_FORMAT;
  }
  return dayjs(date).format(format);
}
var relativeToNow = function relativeToNow(date) {
  return dayjs(date).toNow();
};
var relativeFromNow = function relativeFromNow(date) {
  return dayjs(date).fromNow();
};
var parseDate = function parseDate(date) {
  return dayjs(date).toDate();
};
var formatDurationMillis = function formatDurationMillis(duration) {
  var dur = Math.max(1000, duration); // 不足1s显示1s
  return dayjs.duration(dur, "milliseconds").format("D[d] H[h] m[m] s[s]").replace(/\b0[dhms]\b/g, "");
};
var formatDurationBetween = function formatDurationBetween(startTime, endTime) {
  var diffMillis = dayjs(endTime).diff(dayjs(startTime), "milliseconds");
  return formatDurationMillis(diffMillis);
};
var formatMarkdownLink = function formatMarkdownLink(mdStr, baseUrl, sub_path) {
  // const linkReg = /(?<!!)\[(.*?)\]\((.*?)\)/gi;
  var linkReg = /\[(.*?)\]\((.*?)\)/gi; // (?<!!) 不做图片格式的字符串过滤
  if (!sub_path) return mdStr.replace(linkReg, "[$1](" + baseUrl + "/blob/master/$2)");
  return mdStr.replace(linkReg, "[$1](" + baseUrl + "/blob/master/" + sub_path + "/$2)");
};
function formatFileSize(size) {
  if (size < 1024) {
    return size + " bytes";
  } else if (size >= 1024 && size < 1048576) {
    return (size / 1024).toFixed(1) + " KB";
  } else {
    return (size / 1048576).toFixed(1) + " MB";
  }
}

export { DEFAULT_DATE_TIME_FORMAT, formatDate, formatDurationBetween, formatDurationMillis, formatFileSize, formatMarkdownLink, parseDate, relativeFromNow, relativeToNow };
//# sourceMappingURL=web-utils.esm.js.map
